import React, { useEffect, useState } from "react";
import SectionHeader from "../components/SectionHeader";
import { getDocketEntries } from "../services/docketEntryService";
import { getBranches } from "../services/branchService";
import { useSelector } from "react-redux";
import { UploadCloudIcon } from "lucide-react";

const PodUpload = () => {
  const today = new Date().toISOString().split("T")[0];
  const { user } = useSelector((state) => state.user);

  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [search, setSearch] = useState("");
  const [docketList, setDocketList] = useState([]);
  const [branches, setBranches] = useState([]);
  // To keep track of uploaded files per docket
  const [uploadedFiles, setUploadedFiles] = useState({});

  const handleGetDocketList = async () => {
    try {
      const response = await getDocketEntries(selectedBranch);
      if (response?.status === 200) {
        setDocketList(response?.data || []);
      } else {
        console.error("Failed to fetch docket list:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching docket list:", error);
    }
  };

  const handleGetBranches = async () => {
    try {
      const response = await getBranches();
      if (response?.status === 200) {
        setBranches(response?.data);
      } else {
        console.error("Failed to fetch branches:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching branches:", error);
    }
  };

  useEffect(() => {
    handleGetBranches();
    if (user?.role === "EMPLOYEE") {
      setSelectedBranch(user?.branch?.code || "");
    }
  }, [user]);

  useEffect(() => {
    if (selectedBranch) {
      handleGetDocketList();
    }
  }, [selectedBranch]);

  const handleFileUpload = (docketId, file) => {
    if (file) {
      setUploadedFiles((prev) => ({
        ...prev,
        [docketId]: file,
      }));
    }
  };

  const filteredDockets = docketList?.filter((docket) => {
    const matchesSearch =
      docket?.docketNumber?.toLowerCase().includes(search.toLowerCase()) ||
      docket?.bookingDate?.toLowerCase().includes(search.toLowerCase());

    const docketDate = docket?.bookingDate;

    const matchesDate =
      (!fromDate || docketDate >= fromDate) &&
      (!toDate || docketDate <= toDate);

    // const matchesBranch =
    //   !selectedBranch || docket?.branchCode === selectedBranch;

    return matchesSearch && matchesDate;
  });
  // const matchesBranch =
  //   !selectedBranch || docket?.branchId === selectedBranch;
  console.log("branch---->", selectedBranch)
  return (
    <div className="p-3 bg-slate-200 min-h-full">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-2">
        <SectionHeader
          title="POD Upload"
          subTitle="Upload Proof of Delivery for Dockets"
        />

        <div className="flex items-center gap-2 w-full md:w-auto">
          {/* Date Filter */}
          <div className="flex items-center gap-2 bg-white border rounded-lg px-3 py-1">
            <div className="flex items-center gap-1">
              <span className="text-xs text-gray-500">From</span>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="px-2 py-1 text-sm bg-transparent outline-none"
              />
            </div>
            <span className="text-gray-400">→</span>
            <div className="flex items-center gap-1">
              <span className="text-xs text-gray-500">To</span>
              <input
                type="date"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                className="px-2 py-1 text-sm bg-transparent outline-none"
              />
            </div>
          </div>

          {/* Branch Filter */}
          <div>
            <select
              value={selectedBranch}
              onChange={(e) => setSelectedBranch(e.target.value)}
              className="px-4 py-2 border rounded-md text-sm bg-white"
            >
              <option value="">Select Branch</option>
              {branches?.map((b) => (
                <option key={b._id} value={b.branchCode}>
                  {b.branchName}
                </option>
              ))}
            </select>
          </div>

          {/* Search */}
          <input
            type="text"
            placeholder="Search docket..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="md:w-72 px-4 py-2 border rounded-lg text-sm"
          />
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white border rounded-xl overflow-hidden mt-4">
        <div className="overflow-x-auto">
          <table className="min-w-full border-2">
            <thead className="bg-gray-100 text-xs uppercase text-gray-500">
              <tr>
                <th className="px-4 py-3 text-center">Docket Id</th>
                <th className="px-4 py-3 border-l">Date</th>
                <th className="px-4 py-3 border-l">Time</th>
                <th className="px-4 py-3 border-l">No of Box</th>
                <th className="px-4 py-3 border-l text-center">Actual Wt (Kg)</th>
                <th className="px-4 py-3 border-l text-center">Charged Wt (Kg)</th>
                <th className="px-4 py-3 border-l text-center">POD Status</th>
                <th className="px-4 py-3 border-l text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredDockets?.map((docket) => (
                <tr key={docket._id} className="border-t text-sm">
                  <td className="px-4 py-3 border-l font-medium text-center">
                    {docket?.docketNumber}
                  </td>
                  <td className="px-4 py-3 border-l text-center">
                    {docket?.bookingDate}
                  </td>
                  <td className="px-4 py-3 border-l text-center">
                    {docket?.bookingTime}
                  </td>
                  <td className="px-4 py-3 border-l text-center">
                    {docket?.numberOfBoxes}
                  </td>
                  <td className="px-4 py-3 border-l text-center">
                    {docket?.actualWeight}
                  </td>
                  <td className="px-4 py-3 border-l text-center">
                    {docket?.chargedWeight}
                  </td>
                  <td className="px-4 py-3 border-l text-center">

                    <span className="text-amber-500 font-semibold">{docket?.pod_status || "PENDING"}</span>

                  </td>
                  <td className="px-4 py-3 border-l text-center">
                    <label
                      htmlFor={`pod-upload-${docket._id}`}
                      className="inline-flex items-center gap-1 px-3 py-1 bg-sky-600 hover:bg-sky-700 text-white rounded text-xs cursor-pointer transition-colors"
                    >
                      <UploadCloudIcon size={16} color="white" />
                      Upload
                    </label>
                    <input
                      id={`pod-upload-${docket._id}`}
                      type="file"
                      accept="image/*"
                      className="hidden"
                      onChange={(e) =>
                        handleFileUpload(docket._id, e.target.files[0])
                      }
                    />
                    {uploadedFiles[docket._id] && (
                      <div className="mt-1 text-[10px] text-gray-500 truncate max-w-[100px] mx-auto">
                        {uploadedFiles[docket._id].name}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
              {filteredDockets?.length === 0 && (
                <tr className="h-80">
                  <td colSpan="8" className="py-6 text-center text-gray-500">
                    No dockets found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PodUpload;
